<div class="local-messages" *ngIf="control.invalid && (control.dirty || control.touched)">
    <ng-content></ng-content>
    <div *ngIf="control.errors.invalidNi">
      {{niMessage}}
    </div>
</div>
  